import createClient from "../../helpers/api-client";

const storeSuffix = "Contract";

// Actions
export const SEND_CONTRACT_REQUEST = `sendContractRequest${storeSuffix}`;
export const FETCH_CONTRACT_FOR_REQUEST = `fetchContractForRequest${storeSuffix}`;
export const FETCH_REQUEST_IDS_WITH_CONTRACT = `fetchContractsForContractor${storeSuffix}`;
export const CREATE_CONTRACT = `createContract${storeSuffix}`;
export const GET_EDIT_CONTRACT_LINK = `getEditContractLink${storeSuffix}`;

export const ABORT_CONTRACT_REQUEST = `sendAbortContract${storeSuffix}`;

// Mutations

export const SET_CONTRACT_REQUESTED_FLAG = `setContractRequestedFlagMutation${storeSuffix}`;
export const SET_ERROR = `setErrorMutation${storeSuffix}`;
export const SET_IS_LOADING = `setIsLoading${storeSuffix}`;
export const RECEIVED_DATA = `recievedData${storeSuffix}`;
export const RECEIVED_CONTRACT_LIST = `recievedContractListData${storeSuffix}`;
export const CREATE_SUCCESS = `createSuccess${storeSuffix}`;
export const RESET_STATE = `resetStateMutation${storeSuffix}`;

// Getters

export const GET_CONTRACT = `getContractGetter${storeSuffix}`;
export const GET_CASE = `getCaseGetter${storeSuffix}`;
export const GET_CONTRACT_URL = `getContractUrlGetter${storeSuffix}`;
export const GET_CONTRACT_REQUEST_IDS = `getContractsGetter${storeSuffix}`;

export const GET_IS_CONTRACT_REQUESTED = `getIsContractRequestedGetter${storeSuffix}`;
export const GET_ERROR = `getErrorGetter${storeSuffix}`;
export const IS_LOADING = `getIsLoading${storeSuffix}`;
// export const GET_IS_LOADING = `getIsLoading${storeSuffix}`;
export const GET_CONTRACT_ID = `getContractID${storeSuffix}`;
export const GET_CONTRACT_TYPES = `getContractTypes${storeSuffix}`;

export const modelState = () => ({
    contract: {
        error: null,
        isLoading: false,
        contractRequested: false,
        contract: null,
        data: null,
        contractUrl: null,
        contractRequestIds: [],
        contractTypes: {
            abs18 : 1,
            ContractorForm : 2
        }
    }
});

export const actions = {
    [SEND_CONTRACT_REQUEST]: async (
        { state, commit, dispatch },
        { requestId, ContractorContactId }
    ) => {
        return new Promise(async (resolve, reject) => {
            try {
                commit(SET_IS_LOADING, true);
                const apiClient = createClient(state);
                const data = {
                    ContractorId: ContractorContactId
                };
                const res = await apiClient.post(
                    `/api/contract/${requestId}/request`,
                    data
                );
                commit(SET_IS_LOADING, false);
                dispatch(FETCH_CONTRACT_FOR_REQUEST, requestId);
                // commit(SET_CONTRACT_REQUESTED_FLAG, true);
                resolve(res);
            } catch (error) {
                commit(SET_ERROR, true);
                resolve(error);
            }
        });
    },
    [FETCH_CONTRACT_FOR_REQUEST]: async ({ state, commit }, requestId) => {
        try {
            const apiClient = createClient(state);

            const response = await apiClient.get(`/api/contract/${requestId}`);

            commit(RECEIVED_DATA, response);
            return response;
        } catch (error) {
            // console.log('Error: FETCH_CONTRACT_FOR_REQUEST', error)
            commit(SET_ERROR, error);
            return error;
        }
        // })
    },
    [FETCH_REQUEST_IDS_WITH_CONTRACT]: async ({ state, commit }) => {
        try {
            const apiClient = createClient(state);

            const response = await apiClient.get(`/api/contracts`);

            commit(RECEIVED_CONTRACT_LIST, response);
            return response;
        } catch (error) {
            // console.log('Error: FETCH_REQUEST_IDS_WITH_CONTRACT', error)
            commit(SET_ERROR, error);
            return error;
        }
        // })
    },
    [CREATE_CONTRACT]: async ({ state, commit }, type) => {
        commit(SET_IS_LOADING, true);
        try {
            const apiClient = createClient(state);

            const requestId = state.contract.data
                ? state.contract.data.RequestId
                : null;

            if (!requestId) commit(SET_ERROR, "No requestId");
           
            let response = null;
            switch(type) {
                case state.contract.contractTypes.abs18 :
                        response = await apiClient.post(
                            `/api/contract/${requestId}/create/abs18`
                        );
                        break;
                case state.contract.contractTypes.standardContract :
                        response = await apiClient.post(
                            `/api/contract/${requestId}/create/contractorform`
                        );
                        break;

            }
            
            commit(CREATE_SUCCESS, response);
           

            return response;
        } catch (error) {
            commit(SET_ERROR, error);
            return error;
        }
    },
    [GET_EDIT_CONTRACT_LINK]: async ({ state, commit }) =>{
        return new Promise(async (resolve, reject) => {
            commit(SET_IS_LOADING, true);
            try {
                const apiClient = createClient(state);

                const requestId = state.contract.data
                    ? state.contract.data.RequestId
                    : null;

                if (!requestId) commit(SET_ERROR, "No requestId");

                const response = await apiClient.get(
                    `/api/contract/${requestId}/redirecturl`
                );
                
                commit(SET_IS_LOADING, false);

                resolve(response.data);
                
            } catch (error) {
                commit(SET_ERROR, error);
                resolve(error);
            }
        });
    },
    [ABORT_CONTRACT_REQUEST]: async ({ state, commit }, contractId) => {
        try {
            const apiClient = createClient(state);
            const res = await apiClient.post(
                `/api/contract/abort/${contractId}`
            );
        } catch (error) {}
    }
};

export const mutations = {
    [RECEIVED_DATA]: (state, payload) => {
        const { data } = payload;
        state.contract.isLoading = false;
        state.contract.error = null;
        state.contract.data = data ? data.Contract : null;
        state.contract.contract = data.Case;
        state.contract.contractUrl = data.ContractUrl;
        if (data.Contract) state.contract.contractRequested = true;
        else state.contract.contractRequested = false;
    },
    [RECEIVED_CONTRACT_LIST]: (state, payload) => {
        const { data } = payload;
        state.contract.isLoading = false;
        state.contract.error = null;
        state.contract.contractRequestIds = data ? data.Contracts : [];
    },
    
    [CREATE_SUCCESS]: (state, payload) => {
        const { data } = payload;
        state.contract.isLoading = false;
        state.contract.error = null;
        state.contract.contract = data.Case;
        state.contract.contractUrl = data.ContractUrl;
    },
    [SET_ERROR]: (state, error) => {
        state.contract.isLoading = false;
        state.contract.error = error;
    },
    [SET_IS_LOADING]: (state, bool) => {
        state.contract.isLoading = bool;
    },
    [SET_CONTRACT_REQUESTED_FLAG]: (state, bool) => {
        state.contract.contractRequested = bool
    },
    [RESET_STATE]: state => {
        state.contract.contractRequested = false;
        state.contract.contract = null;
        state.contract.data = null;
        state.contract.contractUrl = null;
        state.contract.contractRequestIds = [];   
    }
};

export const getters = {
    [GET_CONTRACT]: state => state.contract.data,
    [GET_CONTRACT_URL]: state => state.contract.contractUrl,
    [GET_CASE]: state => state.contract.contract,
    [GET_CONTRACT_REQUEST_IDS]: state => state.contract.contractRequestIds,
    [GET_IS_CONTRACT_REQUESTED]: state => state.contract.contractRequested,
    [GET_ERROR]: state => state.contract.error,
    // [GET_IS_LOADING]: state => state.contract.isLoading
    [IS_LOADING]: state => state.contract.isLoading,
    [GET_CONTRACT_TYPES]: state => state.contract.contractTypes
};


// WEBPACK FOOTER //
// ./src/store/store-models/contract-model.js